import { GalleryItemDto } from "../components/blocks/marketing/gallery/GalleryBlockUtils";

export const defaultGallery: GalleryItemDto[] = [
  { type: "image", title: "Dashboard", src: `${process.env.SUPABASE_API_URL}/storage/v1/object/public/public-image//lunova-dashboard-v2.png` }
];
